import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const submitContact = (data) => client.post("/contact", data).then((r) => r.data);
export const submitQuote = (data) => client.post("/quotes", data).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post("/newsletter", { email }).then((r) => r.data);
export const submitApplication = (data) => client.post("/applications", data).then((r) => r.data);

export const getErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const d = detail[0];
    const field = Array.isArray(d.loc) ? d.loc[d.loc.length - 1] : "";
    return `${field ? field + ": " : ""}${d.msg}`;
  }
  return fallback;
};
